import { z } from 'zod';

import { oneTimeCodePattern } from '@paid-ui/regexps';

export const oneTimeCodeSchema = z
  .string()
  .min(1, 'Required field')
  .regex(oneTimeCodePattern, 'One time code must be 6 digits.');
